//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IAdminClient {

    getJobs(signal?: AbortSignal): Promise<ScheduledJobView[]>;

    runJob(jobName: string, signal?: AbortSignal): Promise<void>;

    getApiQuota(signal?: AbortSignal): Promise<ApiQuotaUsage[]>;

    getSyncRuns(signal?: AbortSignal): Promise<RecentSyncRunView[]>;
}

export class AdminClient implements IAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getJobs(signal?: AbortSignal): Promise<ScheduledJobView[]> {
        let url_ = this.baseUrl + "/api/v1/admin/jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobs(_response);
        });
    }

    protected processGetJobs(response: Response): Promise<ScheduledJobView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobView[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduledJobView[]>(null as any);
    }

    runJob(jobName: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admin/jobs/{jobName}/run";
        if (jobName === undefined || jobName === null)
            throw new globalThis.Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunJob(_response);
        });
    }

    protected processRunJob(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiQuota(signal?: AbortSignal): Promise<ApiQuotaUsage[]> {
        let url_ = this.baseUrl + "/api/v1/admin/api-quota";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiQuota(_response);
        });
    }

    protected processGetApiQuota(response: Response): Promise<ApiQuotaUsage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiQuotaUsage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiQuotaUsage[]>(null as any);
    }

    getSyncRuns(signal?: AbortSignal): Promise<RecentSyncRunView[]> {
        let url_ = this.baseUrl + "/api/v1/admin/sync-runs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSyncRuns(_response);
        });
    }

    protected processGetSyncRuns(response: Response): Promise<RecentSyncRunView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentSyncRunView[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentSyncRunView[]>(null as any);
    }
}

export interface IBrokerAccountsClient {

    previewHistory(brokerAccountId: number, model: IbkrHistoryImportModel, signal?: AbortSignal): Promise<IbkrHistoryImportPreview>;

    importHistory(brokerAccountId: number, model: IbkrHistoryImportModel, signal?: AbortSignal): Promise<CsvImportResult>;

    updateAccount(brokerAccountId: number, model: BrokerAccountUpdateModel, signal?: AbortSignal): Promise<BrokerAccountView>;

    requestSync(brokerAccountId: number, signal?: AbortSignal): Promise<void>;

    getSyncRuns(brokerAccountId: number, signal?: AbortSignal): Promise<SyncRunView[]>;

    getReconciliation(brokerAccountId: number, signal?: AbortSignal): Promise<BrokerReconciliationView>;
}

export class BrokerAccountsClient implements IBrokerAccountsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    previewHistory(brokerAccountId: number, model: IbkrHistoryImportModel, signal?: AbortSignal): Promise<IbkrHistoryImportPreview> {
        let url_ = this.baseUrl + "/api/v1/broker-accounts/{brokerAccountId}/history/preview";
        if (brokerAccountId === undefined || brokerAccountId === null)
            throw new globalThis.Error("The parameter 'brokerAccountId' must be defined.");
        url_ = url_.replace("{brokerAccountId}", encodeURIComponent("" + brokerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreviewHistory(_response);
        });
    }

    protected processPreviewHistory(response: Response): Promise<IbkrHistoryImportPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IbkrHistoryImportPreview;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IbkrHistoryImportPreview>(null as any);
    }

    importHistory(brokerAccountId: number, model: IbkrHistoryImportModel, signal?: AbortSignal): Promise<CsvImportResult> {
        let url_ = this.baseUrl + "/api/v1/broker-accounts/{brokerAccountId}/history/import";
        if (brokerAccountId === undefined || brokerAccountId === null)
            throw new globalThis.Error("The parameter 'brokerAccountId' must be defined.");
        url_ = url_.replace("{brokerAccountId}", encodeURIComponent("" + brokerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportHistory(_response);
        });
    }

    protected processImportHistory(response: Response): Promise<CsvImportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CsvImportResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CsvImportResult>(null as any);
    }

    updateAccount(brokerAccountId: number, model: BrokerAccountUpdateModel, signal?: AbortSignal): Promise<BrokerAccountView> {
        let url_ = this.baseUrl + "/api/v1/broker-accounts/{brokerAccountId}";
        if (brokerAccountId === undefined || brokerAccountId === null)
            throw new globalThis.Error("The parameter 'brokerAccountId' must be defined.");
        url_ = url_.replace("{brokerAccountId}", encodeURIComponent("" + brokerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAccount(_response);
        });
    }

    protected processUpdateAccount(response: Response): Promise<BrokerAccountView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerAccountView;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerAccountView>(null as any);
    }

    requestSync(brokerAccountId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/broker-accounts/{brokerAccountId}/sync";
        if (brokerAccountId === undefined || brokerAccountId === null)
            throw new globalThis.Error("The parameter 'brokerAccountId' must be defined.");
        url_ = url_.replace("{brokerAccountId}", encodeURIComponent("" + brokerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestSync(_response);
        });
    }

    protected processRequestSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSyncRuns(brokerAccountId: number, signal?: AbortSignal): Promise<SyncRunView[]> {
        let url_ = this.baseUrl + "/api/v1/broker-accounts/{brokerAccountId}/sync-runs";
        if (brokerAccountId === undefined || brokerAccountId === null)
            throw new globalThis.Error("The parameter 'brokerAccountId' must be defined.");
        url_ = url_.replace("{brokerAccountId}", encodeURIComponent("" + brokerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSyncRuns(_response);
        });
    }

    protected processGetSyncRuns(response: Response): Promise<SyncRunView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SyncRunView[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncRunView[]>(null as any);
    }

    getReconciliation(brokerAccountId: number, signal?: AbortSignal): Promise<BrokerReconciliationView> {
        let url_ = this.baseUrl + "/api/v1/broker-accounts/{brokerAccountId}/reconciliation";
        if (brokerAccountId === undefined || brokerAccountId === null)
            throw new globalThis.Error("The parameter 'brokerAccountId' must be defined.");
        url_ = url_.replace("{brokerAccountId}", encodeURIComponent("" + brokerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReconciliation(_response);
        });
    }

    protected processGetReconciliation(response: Response): Promise<BrokerReconciliationView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerReconciliationView;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerReconciliationView>(null as any);
    }
}

export interface IBrokerConnectionsClient {

    getConnections(signal?: AbortSignal): Promise<BrokerConnectionView[]>;

    createConnection(model: BrokerConnectionCreateModel, signal?: AbortSignal): Promise<BrokerConnectionView>;

    updateConnection(brokerConnectionId: number, model: BrokerConnectionUpdateModel, signal?: AbortSignal): Promise<BrokerConnectionView>;

    deleteConnection(brokerConnectionId: number, signal?: AbortSignal): Promise<void>;

    getAccounts(brokerConnectionId: number, signal?: AbortSignal): Promise<BrokerAccountView[]>;
}

export class BrokerConnectionsClient implements IBrokerConnectionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getConnections(signal?: AbortSignal): Promise<BrokerConnectionView[]> {
        let url_ = this.baseUrl + "/api/v1/broker-connections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConnections(_response);
        });
    }

    protected processGetConnections(response: Response): Promise<BrokerConnectionView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerConnectionView[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerConnectionView[]>(null as any);
    }

    createConnection(model: BrokerConnectionCreateModel, signal?: AbortSignal): Promise<BrokerConnectionView> {
        let url_ = this.baseUrl + "/api/v1/broker-connections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConnection(_response);
        });
    }

    protected processCreateConnection(response: Response): Promise<BrokerConnectionView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerConnectionView;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerConnectionView>(null as any);
    }

    updateConnection(brokerConnectionId: number, model: BrokerConnectionUpdateModel, signal?: AbortSignal): Promise<BrokerConnectionView> {
        let url_ = this.baseUrl + "/api/v1/broker-connections/{brokerConnectionId}";
        if (brokerConnectionId === undefined || brokerConnectionId === null)
            throw new globalThis.Error("The parameter 'brokerConnectionId' must be defined.");
        url_ = url_.replace("{brokerConnectionId}", encodeURIComponent("" + brokerConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateConnection(_response);
        });
    }

    protected processUpdateConnection(response: Response): Promise<BrokerConnectionView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerConnectionView;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerConnectionView>(null as any);
    }

    deleteConnection(brokerConnectionId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/broker-connections/{brokerConnectionId}";
        if (brokerConnectionId === undefined || brokerConnectionId === null)
            throw new globalThis.Error("The parameter 'brokerConnectionId' must be defined.");
        url_ = url_.replace("{brokerConnectionId}", encodeURIComponent("" + brokerConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConnection(_response);
        });
    }

    protected processDeleteConnection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAccounts(brokerConnectionId: number, signal?: AbortSignal): Promise<BrokerAccountView[]> {
        let url_ = this.baseUrl + "/api/v1/broker-connections/{brokerConnectionId}/accounts";
        if (brokerConnectionId === undefined || brokerConnectionId === null)
            throw new globalThis.Error("The parameter 'brokerConnectionId' must be defined.");
        url_ = url_.replace("{brokerConnectionId}", encodeURIComponent("" + brokerConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccounts(_response);
        });
    }

    protected processGetAccounts(response: Response): Promise<BrokerAccountView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerAccountView[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerAccountView[]>(null as any);
    }
}

export interface ICorporateActionsClient {

    getCorporateActions(status: CorporateActionStatus | null | undefined, instrumentId: number | null | undefined, signal?: AbortSignal): Promise<CorporateActionListItem[]>;

    createSplit(model: SplitCreateModel, signal?: AbortSignal): Promise<CorporateActionListItem>;

    approve(corporateActionId: number, signal?: AbortSignal): Promise<void>;

    reject(corporateActionId: number, signal?: AbortSignal): Promise<void>;
}

export class CorporateActionsClient implements ICorporateActionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCorporateActions(status: CorporateActionStatus | null | undefined, instrumentId: number | null | undefined, signal?: AbortSignal): Promise<CorporateActionListItem[]> {
        let url_ = this.baseUrl + "/api/v1/corporate-actions?";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (instrumentId !== undefined && instrumentId !== null)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateActions(_response);
        });
    }

    protected processGetCorporateActions(response: Response): Promise<CorporateActionListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CorporateActionListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CorporateActionListItem[]>(null as any);
    }

    createSplit(model: SplitCreateModel, signal?: AbortSignal): Promise<CorporateActionListItem> {
        let url_ = this.baseUrl + "/api/v1/corporate-actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSplit(_response);
        });
    }

    protected processCreateSplit(response: Response): Promise<CorporateActionListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CorporateActionListItem;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CorporateActionListItem>(null as any);
    }

    approve(corporateActionId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/corporate-actions/{corporateActionId}/approve";
        if (corporateActionId === undefined || corporateActionId === null)
            throw new globalThis.Error("The parameter 'corporateActionId' must be defined.");
        url_ = url_.replace("{corporateActionId}", encodeURIComponent("" + corporateActionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reject(corporateActionId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/corporate-actions/{corporateActionId}/reject";
        if (corporateActionId === undefined || corporateActionId === null)
            throw new globalThis.Error("The parameter 'corporateActionId' must be defined.");
        url_ = url_.replace("{corporateActionId}", encodeURIComponent("" + corporateActionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDashboardClient {

    getHealth(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<PortfolioHealth>;

    getSummary(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<PortfolioSummary>;

    getPortfolioSummaries(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<PortfolioSummary[]>;

    getHistory(range: string | undefined, currency: string | undefined, benchmarkInstrumentId: number | null | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<ValueHistoryPoint[]>;

    getAllocation(currency: string | undefined, by: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<AllocationSliceView[]>;

    getMovers(currency: string | undefined, count: number | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<MoverView[]>;

    getUpcomingDividends(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<UpcomingDividendView[]>;
}

export class DashboardClient implements IDashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getHealth(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<PortfolioHealth> {
        let url_ = this.baseUrl + "/api/v1/dashboard/health?";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (portfolioGroupId !== undefined && portfolioGroupId !== null)
            url_ += "portfolioGroupId=" + encodeURIComponent("" + portfolioGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<PortfolioHealth> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioHealth;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioHealth>(null as any);
    }

    getSummary(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<PortfolioSummary> {
        let url_ = this.baseUrl + "/api/v1/dashboard?";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (portfolioGroupId !== undefined && portfolioGroupId !== null)
            url_ += "portfolioGroupId=" + encodeURIComponent("" + portfolioGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: Response): Promise<PortfolioSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioSummary;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioSummary>(null as any);
    }

    getPortfolioSummaries(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<PortfolioSummary[]> {
        let url_ = this.baseUrl + "/api/v1/dashboard/portfolios?";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (portfolioGroupId !== undefined && portfolioGroupId !== null)
            url_ += "portfolioGroupId=" + encodeURIComponent("" + portfolioGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPortfolioSummaries(_response);
        });
    }

    protected processGetPortfolioSummaries(response: Response): Promise<PortfolioSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioSummary[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioSummary[]>(null as any);
    }

    getHistory(range: string | undefined, currency: string | undefined, benchmarkInstrumentId: number | null | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<ValueHistoryPoint[]> {
        let url_ = this.baseUrl + "/api/v1/dashboard/history?";
        if (range === null)
            throw new globalThis.Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "range=" + encodeURIComponent("" + range) + "&";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (benchmarkInstrumentId !== undefined && benchmarkInstrumentId !== null)
            url_ += "benchmarkInstrumentId=" + encodeURIComponent("" + benchmarkInstrumentId) + "&";
        if (portfolioGroupId !== undefined && portfolioGroupId !== null)
            url_ += "portfolioGroupId=" + encodeURIComponent("" + portfolioGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistory(_response);
        });
    }

    protected processGetHistory(response: Response): Promise<ValueHistoryPoint[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueHistoryPoint[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueHistoryPoint[]>(null as any);
    }

    getAllocation(currency: string | undefined, by: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<AllocationSliceView[]> {
        let url_ = this.baseUrl + "/api/v1/dashboard/allocation?";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (by === null)
            throw new globalThis.Error("The parameter 'by' cannot be null.");
        else if (by !== undefined)
            url_ += "by=" + encodeURIComponent("" + by) + "&";
        if (portfolioGroupId !== undefined && portfolioGroupId !== null)
            url_ += "portfolioGroupId=" + encodeURIComponent("" + portfolioGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllocation(_response);
        });
    }

    protected processGetAllocation(response: Response): Promise<AllocationSliceView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllocationSliceView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllocationSliceView[]>(null as any);
    }

    getMovers(currency: string | undefined, count: number | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<MoverView[]> {
        let url_ = this.baseUrl + "/api/v1/dashboard/movers?";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (portfolioGroupId !== undefined && portfolioGroupId !== null)
            url_ += "portfolioGroupId=" + encodeURIComponent("" + portfolioGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMovers(_response);
        });
    }

    protected processGetMovers(response: Response): Promise<MoverView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MoverView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoverView[]>(null as any);
    }

    getUpcomingDividends(currency: string | undefined, portfolioGroupId: number | null | undefined, signal?: AbortSignal): Promise<UpcomingDividendView[]> {
        let url_ = this.baseUrl + "/api/v1/dashboard/upcoming-dividends?";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (portfolioGroupId !== undefined && portfolioGroupId !== null)
            url_ += "portfolioGroupId=" + encodeURIComponent("" + portfolioGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUpcomingDividends(_response);
        });
    }

    protected processGetUpcomingDividends(response: Response): Promise<UpcomingDividendView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpcomingDividendView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpcomingDividendView[]>(null as any);
    }
}

export interface IFxClient {

    getRates(baseCurrency: string | undefined, quoteCurrency: string | undefined, from: string | undefined, to: string | undefined, signal?: AbortSignal): Promise<FxRatePoint[]>;

    getRate(baseCurrency: string | undefined, quoteCurrency: string | undefined, date: string | undefined, signal?: AbortSignal): Promise<FxRateOnDate>;
}

export class FxClient implements IFxClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRates(baseCurrency: string | undefined, quoteCurrency: string | undefined, from: string | undefined, to: string | undefined, signal?: AbortSignal): Promise<FxRatePoint[]> {
        let url_ = this.baseUrl + "/api/v1/fx?";
        if (baseCurrency === null)
            throw new globalThis.Error("The parameter 'baseCurrency' cannot be null.");
        else if (baseCurrency !== undefined)
            url_ += "base=" + encodeURIComponent("" + baseCurrency) + "&";
        if (quoteCurrency === null)
            throw new globalThis.Error("The parameter 'quoteCurrency' cannot be null.");
        else if (quoteCurrency !== undefined)
            url_ += "quote=" + encodeURIComponent("" + quoteCurrency) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRates(_response);
        });
    }

    protected processGetRates(response: Response): Promise<FxRatePoint[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FxRatePoint[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FxRatePoint[]>(null as any);
    }

    getRate(baseCurrency: string | undefined, quoteCurrency: string | undefined, date: string | undefined, signal?: AbortSignal): Promise<FxRateOnDate> {
        let url_ = this.baseUrl + "/api/v1/fx/rate?";
        if (baseCurrency === null)
            throw new globalThis.Error("The parameter 'baseCurrency' cannot be null.");
        else if (baseCurrency !== undefined)
            url_ += "base=" + encodeURIComponent("" + baseCurrency) + "&";
        if (quoteCurrency === null)
            throw new globalThis.Error("The parameter 'quoteCurrency' cannot be null.");
        else if (quoteCurrency !== undefined)
            url_ += "quote=" + encodeURIComponent("" + quoteCurrency) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRate(_response);
        });
    }

    protected processGetRate(response: Response): Promise<FxRateOnDate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FxRateOnDate;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FxRateOnDate>(null as any);
    }
}

export interface IInstrumentsClient {

    search(query: string | undefined, signal?: AbortSignal): Promise<InstrumentSearchResult[]>;

    addInstrument(model: InstrumentAddModel, signal?: AbortSignal): Promise<InstrumentDetail>;

    addYahooInstrument(model: InstrumentYahooAddModel, signal?: AbortSignal): Promise<InstrumentDetail>;

    getUnmapped(signal?: AbortSignal): Promise<UnmappedInstrument[]>;

    getInstrument(instrumentId: number, signal?: AbortSignal): Promise<InstrumentDetail>;

    getSentiment(instrumentId: number, signal?: AbortSignal): Promise<InstrumentHoldingSentiment>;

    getPrices(instrumentId: number, range: string | undefined, adjusted: boolean | undefined, signal?: AbortSignal): Promise<PriceBarView[]>;

    getPriceAtTime(instrumentId: number, timeUtc: string | undefined, type: TransactionType | undefined, signal?: AbortSignal): Promise<InstrumentPriceAtTime>;

    getHoldings(instrumentId: number, currency: string | undefined, signal?: AbortSignal): Promise<InstrumentHoldingView[]>;

    addListing(instrumentId: number, model: InstrumentListingCreateModel, signal?: AbortSignal): Promise<InstrumentDetail>;

    merge(instrumentId: number, model: InstrumentMergeModel, signal?: AbortSignal): Promise<InstrumentDetail>;
}

export class InstrumentsClient implements IInstrumentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    search(query: string | undefined, signal?: AbortSignal): Promise<InstrumentSearchResult[]> {
        let url_ = this.baseUrl + "/api/v1/instruments/search?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "q=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<InstrumentSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentSearchResult[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentSearchResult[]>(null as any);
    }

    addInstrument(model: InstrumentAddModel, signal?: AbortSignal): Promise<InstrumentDetail> {
        let url_ = this.baseUrl + "/api/v1/instruments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddInstrument(_response);
        });
    }

    protected processAddInstrument(response: Response): Promise<InstrumentDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentDetail;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentDetail>(null as any);
    }

    addYahooInstrument(model: InstrumentYahooAddModel, signal?: AbortSignal): Promise<InstrumentDetail> {
        let url_ = this.baseUrl + "/api/v1/instruments/yahoo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddYahooInstrument(_response);
        });
    }

    protected processAddYahooInstrument(response: Response): Promise<InstrumentDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentDetail;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentDetail>(null as any);
    }

    getUnmapped(signal?: AbortSignal): Promise<UnmappedInstrument[]> {
        let url_ = this.baseUrl + "/api/v1/instruments/unmapped";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnmapped(_response);
        });
    }

    protected processGetUnmapped(response: Response): Promise<UnmappedInstrument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnmappedInstrument[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnmappedInstrument[]>(null as any);
    }

    getInstrument(instrumentId: number, signal?: AbortSignal): Promise<InstrumentDetail> {
        let url_ = this.baseUrl + "/api/v1/instruments/{instrumentId}";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInstrument(_response);
        });
    }

    protected processGetInstrument(response: Response): Promise<InstrumentDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentDetail;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentDetail>(null as any);
    }

    getSentiment(instrumentId: number, signal?: AbortSignal): Promise<InstrumentHoldingSentiment> {
        let url_ = this.baseUrl + "/api/v1/instruments/{instrumentId}/sentiment";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSentiment(_response);
        });
    }

    protected processGetSentiment(response: Response): Promise<InstrumentHoldingSentiment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentHoldingSentiment;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentHoldingSentiment>(null as any);
    }

    getPrices(instrumentId: number, range: string | undefined, adjusted: boolean | undefined, signal?: AbortSignal): Promise<PriceBarView[]> {
        let url_ = this.baseUrl + "/api/v1/instruments/{instrumentId}/prices?";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (range === null)
            throw new globalThis.Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "range=" + encodeURIComponent("" + range) + "&";
        if (adjusted === null)
            throw new globalThis.Error("The parameter 'adjusted' cannot be null.");
        else if (adjusted !== undefined)
            url_ += "adjusted=" + encodeURIComponent("" + adjusted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPrices(_response);
        });
    }

    protected processGetPrices(response: Response): Promise<PriceBarView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PriceBarView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PriceBarView[]>(null as any);
    }

    getPriceAtTime(instrumentId: number, timeUtc: string | undefined, type: TransactionType | undefined, signal?: AbortSignal): Promise<InstrumentPriceAtTime> {
        let url_ = this.baseUrl + "/api/v1/instruments/{instrumentId}/price-at-time?";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (timeUtc === null)
            throw new globalThis.Error("The parameter 'timeUtc' cannot be null.");
        else if (timeUtc !== undefined)
            url_ += "timeUtc=" + encodeURIComponent("" + timeUtc) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPriceAtTime(_response);
        });
    }

    protected processGetPriceAtTime(response: Response): Promise<InstrumentPriceAtTime> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentPriceAtTime;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentPriceAtTime>(null as any);
    }

    getHoldings(instrumentId: number, currency: string | undefined, signal?: AbortSignal): Promise<InstrumentHoldingView[]> {
        let url_ = this.baseUrl + "/api/v1/instruments/{instrumentId}/holdings?";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHoldings(_response);
        });
    }

    protected processGetHoldings(response: Response): Promise<InstrumentHoldingView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentHoldingView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentHoldingView[]>(null as any);
    }

    addListing(instrumentId: number, model: InstrumentListingCreateModel, signal?: AbortSignal): Promise<InstrumentDetail> {
        let url_ = this.baseUrl + "/api/v1/instruments/{instrumentId}/listings";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddListing(_response);
        });
    }

    protected processAddListing(response: Response): Promise<InstrumentDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentDetail;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentDetail>(null as any);
    }

    merge(instrumentId: number, model: InstrumentMergeModel, signal?: AbortSignal): Promise<InstrumentDetail> {
        let url_ = this.baseUrl + "/api/v1/instruments/{instrumentId}/merge";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: Response): Promise<InstrumentDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentDetail;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentDetail>(null as any);
    }
}

export interface IPortfolioGroupsClient {

    getPortfolioGroups(signal?: AbortSignal): Promise<PortfolioGroupListItem[]>;

    createPortfolioGroup(model: PortfolioGroupEditModel, signal?: AbortSignal): Promise<PortfolioGroupListItem>;

    updatePortfolioGroup(portfolioGroupId: number, model: PortfolioGroupEditModel, signal?: AbortSignal): Promise<PortfolioGroupListItem>;

    deletePortfolioGroup(portfolioGroupId: number, signal?: AbortSignal): Promise<void>;
}

export class PortfolioGroupsClient implements IPortfolioGroupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPortfolioGroups(signal?: AbortSignal): Promise<PortfolioGroupListItem[]> {
        let url_ = this.baseUrl + "/api/v1/portfolio-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPortfolioGroups(_response);
        });
    }

    protected processGetPortfolioGroups(response: Response): Promise<PortfolioGroupListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioGroupListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioGroupListItem[]>(null as any);
    }

    createPortfolioGroup(model: PortfolioGroupEditModel, signal?: AbortSignal): Promise<PortfolioGroupListItem> {
        let url_ = this.baseUrl + "/api/v1/portfolio-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePortfolioGroup(_response);
        });
    }

    protected processCreatePortfolioGroup(response: Response): Promise<PortfolioGroupListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioGroupListItem;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioGroupListItem>(null as any);
    }

    updatePortfolioGroup(portfolioGroupId: number, model: PortfolioGroupEditModel, signal?: AbortSignal): Promise<PortfolioGroupListItem> {
        let url_ = this.baseUrl + "/api/v1/portfolio-groups/{portfolioGroupId}";
        if (portfolioGroupId === undefined || portfolioGroupId === null)
            throw new globalThis.Error("The parameter 'portfolioGroupId' must be defined.");
        url_ = url_.replace("{portfolioGroupId}", encodeURIComponent("" + portfolioGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePortfolioGroup(_response);
        });
    }

    protected processUpdatePortfolioGroup(response: Response): Promise<PortfolioGroupListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioGroupListItem;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioGroupListItem>(null as any);
    }

    deletePortfolioGroup(portfolioGroupId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/portfolio-groups/{portfolioGroupId}";
        if (portfolioGroupId === undefined || portfolioGroupId === null)
            throw new globalThis.Error("The parameter 'portfolioGroupId' must be defined.");
        url_ = url_.replace("{portfolioGroupId}", encodeURIComponent("" + portfolioGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePortfolioGroup(_response);
        });
    }

    protected processDeletePortfolioGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPortfoliosClient {

    getPortfolios(includeArchived: boolean | undefined, signal?: AbortSignal): Promise<PortfolioListItem[]>;

    createPortfolio(model: PortfolioEditModel, signal?: AbortSignal): Promise<PortfolioListItem>;

    getPortfolio(portfolioId: number, signal?: AbortSignal): Promise<PortfolioDetail>;

    updatePortfolio(portfolioId: number, model: PortfolioEditModel, signal?: AbortSignal): Promise<PortfolioListItem>;

    archivePortfolio(portfolioId: number, signal?: AbortSignal): Promise<void>;

    getSummary(portfolioId: number, currency: string | undefined, signal?: AbortSignal): Promise<PortfolioSummary>;

    getPositions(portfolioId: number, currency: string | undefined, signal?: AbortSignal): Promise<PositionView[]>;

    getPositionsPeriodProfitLoss(portfolioId: number, range: string | undefined, currency: string | undefined, signal?: AbortSignal): Promise<PositionPeriodProfitLossView[]>;

    getHistory(portfolioId: number, range: string | undefined, currency: string | undefined, signal?: AbortSignal): Promise<ValueHistoryPoint[]>;

    getAllocation(portfolioId: number, by: string | undefined, signal?: AbortSignal): Promise<AllocationSliceView[]>;

    getRealizedLots(portfolioId: number, signal?: AbortSignal): Promise<RealizedLotView[]>;
}

export class PortfoliosClient implements IPortfoliosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPortfolios(includeArchived: boolean | undefined, signal?: AbortSignal): Promise<PortfolioListItem[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios?";
        if (includeArchived === null)
            throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPortfolios(_response);
        });
    }

    protected processGetPortfolios(response: Response): Promise<PortfolioListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioListItem[]>(null as any);
    }

    createPortfolio(model: PortfolioEditModel, signal?: AbortSignal): Promise<PortfolioListItem> {
        let url_ = this.baseUrl + "/api/v1/portfolios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePortfolio(_response);
        });
    }

    protected processCreatePortfolio(response: Response): Promise<PortfolioListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioListItem;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioListItem>(null as any);
    }

    getPortfolio(portfolioId: number, signal?: AbortSignal): Promise<PortfolioDetail> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPortfolio(_response);
        });
    }

    protected processGetPortfolio(response: Response): Promise<PortfolioDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioDetail;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioDetail>(null as any);
    }

    updatePortfolio(portfolioId: number, model: PortfolioEditModel, signal?: AbortSignal): Promise<PortfolioListItem> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePortfolio(_response);
        });
    }

    protected processUpdatePortfolio(response: Response): Promise<PortfolioListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioListItem;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioListItem>(null as any);
    }

    archivePortfolio(portfolioId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchivePortfolio(_response);
        });
    }

    protected processArchivePortfolio(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSummary(portfolioId: number, currency: string | undefined, signal?: AbortSignal): Promise<PortfolioSummary> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/summary?";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: Response): Promise<PortfolioSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortfolioSummary;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortfolioSummary>(null as any);
    }

    getPositions(portfolioId: number, currency: string | undefined, signal?: AbortSignal): Promise<PositionView[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/positions?";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPositions(_response);
        });
    }

    protected processGetPositions(response: Response): Promise<PositionView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionView[]>(null as any);
    }

    getPositionsPeriodProfitLoss(portfolioId: number, range: string | undefined, currency: string | undefined, signal?: AbortSignal): Promise<PositionPeriodProfitLossView[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/positions/period-pl?";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (range === null)
            throw new globalThis.Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "range=" + encodeURIComponent("" + range) + "&";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPositionsPeriodProfitLoss(_response);
        });
    }

    protected processGetPositionsPeriodProfitLoss(response: Response): Promise<PositionPeriodProfitLossView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PositionPeriodProfitLossView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionPeriodProfitLossView[]>(null as any);
    }

    getHistory(portfolioId: number, range: string | undefined, currency: string | undefined, signal?: AbortSignal): Promise<ValueHistoryPoint[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/history?";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (range === null)
            throw new globalThis.Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "range=" + encodeURIComponent("" + range) + "&";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistory(_response);
        });
    }

    protected processGetHistory(response: Response): Promise<ValueHistoryPoint[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueHistoryPoint[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueHistoryPoint[]>(null as any);
    }

    getAllocation(portfolioId: number, by: string | undefined, signal?: AbortSignal): Promise<AllocationSliceView[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/allocation?";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (by === null)
            throw new globalThis.Error("The parameter 'by' cannot be null.");
        else if (by !== undefined)
            url_ += "by=" + encodeURIComponent("" + by) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllocation(_response);
        });
    }

    protected processGetAllocation(response: Response): Promise<AllocationSliceView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllocationSliceView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllocationSliceView[]>(null as any);
    }

    getRealizedLots(portfolioId: number, signal?: AbortSignal): Promise<RealizedLotView[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/realized";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRealizedLots(_response);
        });
    }

    protected processGetRealizedLots(response: Response): Promise<RealizedLotView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RealizedLotView[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealizedLotView[]>(null as any);
    }
}

export interface IPriceAlertsClient {

    getAlerts(signal?: AbortSignal): Promise<PriceAlertListItem[]>;

    createAlert(model: PriceAlertCreateModel, signal?: AbortSignal): Promise<PriceAlertListItem>;

    deleteAlert(priceAlertId: number, signal?: AbortSignal): Promise<void>;
}

export class PriceAlertsClient implements IPriceAlertsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAlerts(signal?: AbortSignal): Promise<PriceAlertListItem[]> {
        let url_ = this.baseUrl + "/api/v1/alerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlerts(_response);
        });
    }

    protected processGetAlerts(response: Response): Promise<PriceAlertListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PriceAlertListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PriceAlertListItem[]>(null as any);
    }

    createAlert(model: PriceAlertCreateModel, signal?: AbortSignal): Promise<PriceAlertListItem> {
        let url_ = this.baseUrl + "/api/v1/alerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAlert(_response);
        });
    }

    protected processCreateAlert(response: Response): Promise<PriceAlertListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PriceAlertListItem;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PriceAlertListItem>(null as any);
    }

    deleteAlert(priceAlertId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/alerts/{priceAlertId}";
        if (priceAlertId === undefined || priceAlertId === null)
            throw new globalThis.Error("The parameter 'priceAlertId' must be defined.");
        url_ = url_.replace("{priceAlertId}", encodeURIComponent("" + priceAlertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAlert(_response);
        });
    }

    protected processDeleteAlert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITransactionsClient {

    getTransactions(portfolioId: number, from: string | null | undefined, to: string | null | undefined, type: TransactionType | null | undefined, signal?: AbortSignal): Promise<TransactionListItem[]>;

    createTransaction(portfolioId: number, model: TransactionEditModel, signal?: AbortSignal): Promise<TransactionListItem>;

    getHoldingTransactions(portfolioId: number, instrumentId: number, currency: string | undefined, signal?: AbortSignal): Promise<HoldingTransactionView[]>;

    moveHolding(portfolioId: number, instrumentId: number, model: HoldingMoveModel, signal?: AbortSignal): Promise<void>;

    updateTransaction(portfolioId: number, transactionId: number, model: TransactionEditModel, signal?: AbortSignal): Promise<TransactionListItem>;

    deleteTransaction(portfolioId: number, transactionId: number, signal?: AbortSignal): Promise<void>;

    previewCsvImport(portfolioId: number, model: CsvImportModel, signal?: AbortSignal): Promise<CsvImportPreview>;

    importCsv(portfolioId: number, model: CsvImportModel, signal?: AbortSignal): Promise<CsvImportResult>;
}

export class TransactionsClient implements ITransactionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTransactions(portfolioId: number, from: string | null | undefined, to: string | null | undefined, type: TransactionType | null | undefined, signal?: AbortSignal): Promise<TransactionListItem[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions?";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactions(_response);
        });
    }

    protected processGetTransactions(response: Response): Promise<TransactionListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransactionListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionListItem[]>(null as any);
    }

    createTransaction(portfolioId: number, model: TransactionEditModel, signal?: AbortSignal): Promise<TransactionListItem> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTransaction(_response);
        });
    }

    protected processCreateTransaction(response: Response): Promise<TransactionListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransactionListItem;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionListItem>(null as any);
    }

    getHoldingTransactions(portfolioId: number, instrumentId: number, currency: string | undefined, signal?: AbortSignal): Promise<HoldingTransactionView[]> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions/instruments/{instrumentId}?";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHoldingTransactions(_response);
        });
    }

    protected processGetHoldingTransactions(response: Response): Promise<HoldingTransactionView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HoldingTransactionView[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HoldingTransactionView[]>(null as any);
    }

    moveHolding(portfolioId: number, instrumentId: number, model: HoldingMoveModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions/instruments/{instrumentId}/move";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveHolding(_response);
        });
    }

    protected processMoveHolding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTransaction(portfolioId: number, transactionId: number, model: TransactionEditModel, signal?: AbortSignal): Promise<TransactionListItem> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions/{transactionId}";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (transactionId === undefined || transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTransaction(_response);
        });
    }

    protected processUpdateTransaction(response: Response): Promise<TransactionListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransactionListItem;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionListItem>(null as any);
    }

    deleteTransaction(portfolioId: number, transactionId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions/{transactionId}";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (transactionId === undefined || transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTransaction(_response);
        });
    }

    protected processDeleteTransaction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    previewCsvImport(portfolioId: number, model: CsvImportModel, signal?: AbortSignal): Promise<CsvImportPreview> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions/csv-import/preview";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreviewCsvImport(_response);
        });
    }

    protected processPreviewCsvImport(response: Response): Promise<CsvImportPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CsvImportPreview;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CsvImportPreview>(null as any);
    }

    importCsv(portfolioId: number, model: CsvImportModel, signal?: AbortSignal): Promise<CsvImportResult> {
        let url_ = this.baseUrl + "/api/v1/portfolios/{portfolioId}/transactions/csv-import";
        if (portfolioId === undefined || portfolioId === null)
            throw new globalThis.Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportCsv(_response);
        });
    }

    protected processImportCsv(response: Response): Promise<CsvImportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CsvImportResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CsvImportResult>(null as any);
    }
}

export interface IWatchlistsClient {

    getItems(signal?: AbortSignal): Promise<WatchlistItemView[]>;

    addItem(model: WatchlistItemCreateModel, signal?: AbortSignal): Promise<void>;

    removeItem(instrumentId: number, signal?: AbortSignal): Promise<void>;
}

export class WatchlistsClient implements IWatchlistsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getItems(signal?: AbortSignal): Promise<WatchlistItemView[]> {
        let url_ = this.baseUrl + "/api/v1/watchlists/default/items";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<WatchlistItemView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchlistItemView[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WatchlistItemView[]>(null as any);
    }

    addItem(model: WatchlistItemCreateModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/watchlists/default/items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddItem(_response);
        });
    }

    protected processAddItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeItem(instrumentId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/watchlists/default/items/{instrumentId}";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveItem(_response);
        });
    }

    protected processRemoveItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ScheduledJobView {
    jobName: string;
    cronExpression: string;
    lastRunUtc: string | null;
    nextRunUtc: string | null;
    lastStatus: SyncStatus | null;
    lastMessage: string | null;
}

export type SyncStatus = "Succeeded" | "Failed" | "Running";

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

/** Calls of one provider: the last minute against its limit, and since midnight UTC (failed = no response or HTTP error). */
export interface ApiQuotaUsage {
    provider: DataProvider;
    requestsLastMinute: number;
    limitPerMinute: number;
    requestsToday: number;
    failedRequestsToday: number;
}

export type DataProvider = "Manual" | "EToro" | "IbkrFlex" | "IbkrGateway" | "Csv" | "Ecb" | "Yahoo";

/** A sync run with the broker account and connection it ran for. */
export interface RecentSyncRunView {
    syncRunId: number;
    brokerAccountId: number;
    accountNumber: string;
    provider: DataProvider;
    connectionName: string;
    startedUtc: string;
    finishedUtc: string | null;
    status: SyncStatus;
    inserted: number;
    updated: number;
    skipped: number;
    error: string | null;
}

export interface IbkrHistoryImportPreview {
    rows: CsvImportRow[];
    validRows: number;
    duplicateRows: number;
    errorRows: number;
    ignoredRows: number;
    coveredBySyncRows: number;
    syncCoverageFrom: string | null;
    baseCurrency: string;
    fxLegs: IbkrHistoryFxLeg[];
}

/** A data row as it would be imported; a duplicate was imported before, a row with errors is not imported. */
export interface CsvImportRow {
    lineNumber: number;
    type: TransactionType | null;
    tradeDate: string | null;
    symbol: string | null;
    instrumentId: number | null;
    quantity: number | null;
    price: number | null;
    amount: number | null;
    fee: number;
    currencyCode: string | null;
    note: string | null;
    isDuplicate: boolean;
    errors: CsvRowError[];
}

export type TransactionType = "Buy" | "Sell" | "Dividend" | "Fee" | "Deposit" | "Withdrawal" | "FxConversion" | "Tax";

/** Field is the transaction field in camelCase; Message is a translation key. */
export interface CsvRowError {
    field: string;
    message: string;
}

export interface IbkrHistoryFxLeg {
    lineNumber: number;
    amount: number;
    currencyCode: string;
}

export interface IbkrHistoryImportModel {
    content: string;
    throughDate: string | null;
}

export interface CsvImportResult {
    inserted: number;
    duplicates: number;
    failed: number;
}

export interface BrokerAccountView {
    brokerAccountId: number;
    accountNumber: string;
    portfolioId: number | null;
    portfolioName: string | null;
    includeCfd: boolean;
    syncFromDate: string;
    mismatchCount: number | null;
    reconciledUtc: string | null;
}

export interface BrokerAccountUpdateModel {
    portfolioId: number | null;
    includeCfd: boolean;
    syncFromDate: string;
}

export interface SyncRunView {
    syncRunId: number;
    startedUtc: string;
    finishedUtc: string | null;
    status: SyncStatus;
    inserted: number;
    updated: number;
    skipped: number;
    error: string | null;
}

/** System versus broker quantities of one broker account; ReportedUtc is when the broker last reported its positions. */
export interface BrokerReconciliationView {
    brokerAccountId: number;
    reportedUtc: string | null;
    lines: ReconciliationLine[];
}

/** One instrument; SplitFrom and SplitTo give the split ratio of a pending or likely missing split. */
export interface ReconciliationLine {
    instrumentId: number;
    symbol: string;
    name: string;
    systemQuantity: number;
    brokerQuantity: number;
    difference: number;
    reason: ReconciliationReason;
    splitFrom: number | null;
    splitTo: number | null;
}

/** Likely reason why the system quantity of an instrument differs from the broker quantity. */
export type ReconciliationReason = "Matched" | "PendingSplit" | "MissingSplit" | "MissingTransactions" | "ExtraTransactions";

/** A broker connection as the UI sees it. The protected secret never leaves the server. */
export interface BrokerConnectionView {
    brokerConnectionId: number;
    provider: DataProvider;
    displayName: string;
    flexQueryId: string | null;
    tokenExpiresUtc: string | null;
    lastSyncUtc: string | null;
    lastSyncStatus: SyncStatus | null;
    isActive: boolean;
    accounts: BrokerAccountView[];
}

/** Write-only: the secret and the API key are accepted here and never returned. */
export interface BrokerConnectionCreateModel {
    provider: DataProvider;
    displayName: string;
    secret: string;
    apiKey: string | null;
    flexQueryId: string | null;
    tokenExpiresUtc: string | null;
    accountNumber: string;
    portfolioId: number | null;
    syncFromDate: string;
}

export interface BrokerConnectionUpdateModel {
    displayName: string;
    secret: string | null;
    apiKey: string | null;
    clearApiKey: boolean;
    flexQueryId: string | null;
    tokenExpiresUtc: string | null;
    isActive: boolean;
}

export interface CorporateActionListItem {
    corporateActionId: number;
    instrumentId: number;
    symbol: string;
    type: CorporateActionType;
    effectiveDate: string;
    splitFrom: number | null;
    splitTo: number | null;
    dividendPerShare: number | null;
    dividendCurrency: string | null;
    status: CorporateActionStatus;
    source: DataProvider;
}

export type CorporateActionType = "Split" | "Dividend";

export type CorporateActionStatus = "Pending" | "Applied" | "Rejected";

export interface SplitCreateModel {
    instrumentId: number;
    effectiveDate: string;
    splitFrom: number;
    splitTo: number;
}

export interface PortfolioHealth {
    checkedUtc: string;
    portfolioCount: number;
    issues: PortfolioHealthIssue[];
}

export interface PortfolioHealthIssue {
    type: PortfolioHealthIssueType;
    portfolioId: number;
    portfolioName: string;
    instrumentId: number | null;
    symbol: string | null;
    date: string | null;
    currency: string | null;
    targetCurrency: string | null;
    connectionName: string | null;
    count: number | null;
}

export type PortfolioHealthIssueType = "MissingPrice" | "StalePrice" | "MissingPriceHistory" | "MissingFxRate" | "UnmappedInstrument" | "FailedSync" | "BrokerMismatch";

/** Key figures of a portfolio, or of all portfolios when PortfolioId is null, in Currency. Cash is per currency as held. Percentages are in percent (12.5 = 12.5 %); the TWR covers the calendar year so far. */
export interface PortfolioSummary {
    portfolioId: number | null;
    name: string | null;
    currency: string;
    asOf: string;
    marketValue: number;
    cash: { [key: string]: number; };
    totalValue: number;
    costBasis: number;
    unrealizedPL: number;
    unrealizedPLPct: number;
    realizedPL: number;
    dividends: number;
    dayChange: number;
    dayChangePct: number;
    fxImpact: number;
    twrYtdPct: number;
}

/** Value of a day with the time-weighted return index and the benchmark index, both 1 on the first day of the range. ProfitLoss is the change of the value net of deposits and withdrawals since the first point of the range, 0 on that point. Intraday points also carry the time of the value; their date is that time's day in Vilnius. */
export interface ValueHistoryPoint {
    date: string;
    value: number;
    profitLoss: number;
    twrIndex: number;
    benchmarkIndex: number | null;
    timeUtc: string | null;
}

/** Allocation slice in the valuation currency, weight in percent. Grouped by instrument the key is the instrument id and the label its symbol; otherwise both are the group (type, currency, sector, country), null for holdings without that attribute. */
export interface AllocationSliceView {
    key: string | null;
    label: string | null;
    valueBase: number;
    weightPct: number;
}

/** Held instrument with its move since the previous close. The price is in the instrument currency, DayChange and MarketValue are the holdings of all portfolios together in the display currency; DayChangePct is in percent. */
export interface MoverView {
    instrumentId: number;
    symbol: string;
    name: string;
    currency: string;
    lastPrice: number;
    priceDate: string;
    dayChangePct: number;
    dayChange: number;
    marketValue: number;
}

/** Dividend of a held instrument effective today or later. Quantity is held by all portfolios together today; ExpectedAmount is that quantity times the dividend per share in the display currency at today's rate. */
export interface UpcomingDividendView {
    corporateActionId: number;
    instrumentId: number;
    symbol: string;
    name: string;
    effectiveDate: string;
    dividendPerShare: number;
    dividendCurrency: string;
    quantity: number;
    expectedAmount: number;
    status: CorporateActionStatus;
}

export interface FxRatePoint {
    date: string;
    rate: number;
    source: DataProvider;
}

/** 1 BaseCurrency = Rate QuoteCurrency on Date; Rate is null when no rate is known for that date. */
export interface FxRateOnDate {
    baseCurrency: string;
    quoteCurrency: string;
    date: string;
    rate: number | null;
}

/** A search hit: InstrumentId is set for instruments already in the system, EToroInstrumentId for eToro hits not yet added. */
export interface InstrumentSearchResult {
    instrumentId: number | null;
    symbol: string;
    name: string;
    type: InstrumentType | null;
    exchange: string | null;
    currencyCode: string | null;
    eToroInstrumentId: string | null;
    yahooSymbol: string | null;
}

export type InstrumentType = "Stock" | "Etf";

export interface InstrumentDetail {
    instrumentId: number;
    symbol: string;
    name: string;
    type: InstrumentType;
    exchange: string | null;
    currencyCode: string;
    isin: string | null;
    sector: string | null;
    country: string | null;
    lastPrice: number | null;
    dayChangePct: number | null;
    lastPriceSyncUtc: string | null;
    listings: InstrumentListingView[];
}

export interface InstrumentListingView {
    provider: DataProvider;
    externalId: string;
    externalSymbol: string | null;
}

export interface InstrumentAddModel {
    eToroInstrumentId: string;
    currencyCode: string | null;
}

export interface InstrumentYahooAddModel {
    yahooSymbol: string;
}

/** An instrument without an eToro listing (no price source) with eToro instruments that may be the same. */
export interface UnmappedInstrument {
    instrumentId: number;
    symbol: string;
    name: string;
    isin: string | null;
    exchange: string | null;
    currencyCode: string;
    suggestions: InstrumentSearchResult[];
}

export interface InstrumentHoldingSentiment {
    buyHoldingPct: number | null;
    sellHoldingPct: number | null;
}

/** Daily bar; adjusted bars are divided by the splits that happened after their date. */
export interface PriceBarView {
    date: string;
    open: number;
    high: number;
    low: number;
    close: number;
    source: DataProvider;
}

export interface InstrumentPriceAtTime {
    instrumentId: number;
    currencyCode: string;
    timeUtc: string;
    type: TransactionType;
    price: number | null;
    priceTimeUtc: string | null;
    source: DataProvider | null;
}

/** Open position of an instrument in one portfolio. Average cost is in the instrument currency, MarketValue, UnrealizedPL, RealizedPL, Dividends and TotalPL in the display currency; the weight is the share of the portfolio market value in percent. */
export interface InstrumentHoldingView {
    portfolioId: number;
    portfolioName: string;
    currency: string;
    quantity: number;
    averageCost: number;
    marketValue: number;
    weightPct: number;
    unrealizedPL: number;
    unrealizedPLPct: number;
    realizedPL: number;
    dividends: number;
    totalPL: number;
}

export interface InstrumentListingCreateModel {
    provider: DataProvider;
    externalId: string;
}

export interface InstrumentMergeModel {
    targetInstrumentId: number;
}

/** PortfolioCount: active portfolios of the group; archived ones keep their group but are not counted. */
export interface PortfolioGroupListItem {
    portfolioGroupId: number;
    name: string;
    portfolioCount: number;
}

export interface PortfolioGroupEditModel {
    name: string;
}

export interface PortfolioListItem {
    portfolioId: number;
    name: string;
    baseCurrency: string;
    isArchived: boolean;
    portfolioGroupId: number | null;
}

/** IsRecalculationPending: a change is queued and positions, lots and snapshots do not reflect it yet. */
export interface PortfolioDetail {
    portfolioId: number;
    name: string;
    baseCurrency: string;
    isArchived: boolean;
    benchmarkInstrumentId: number | null;
    benchmarkSymbol: string | null;
    portfolioGroupId: number | null;
    portfolioGroupName: string | null;
    isRecalculationPending: boolean;
}

/** Open position. Prices are in the instrument currency, the other amounts in the requested currency; percentages are in percent. In the instrument currency the amounts hold no FX change of the portfolio base currency. LastPrice is null for an instrument without any price (valued at cost); PriceDate is the trading day of the price, so the UI can mark a stale one. Unrealized P/L = price P/L + FX impact. Realized P/L and dividends are kept in base currency and converted at today's rate in any currency; total P/L = unrealized P/L + realized P/L + dividends. */
export interface PositionView {
    instrumentId: number;
    symbol: string;
    name: string;
    instrumentType: InstrumentType;
    currency: string;
    quantity: number;
    averageCost: number;
    lastPrice: number | null;
    priceDate: string | null;
    marketValue: number;
    weightPct: number;
    dayChange: number;
    dayChangePct: number;
    unrealizedPL: number;
    unrealizedPLPct: number;
    pricePL: number;
    fxImpact: number;
    realizedPL: number;
    dividends: number;
    totalPL: number;
}

/** Profit and loss of an open position over a chart range in the requested currency: the value change net of the buys and sells in the range plus the dividends in the range. The percentage is of the value at the start plus the buys in the range. */
export interface PositionPeriodProfitLossView {
    instrumentId: number;
    valueChange: number;
    dividends: number;
    totalPL: number;
    totalPLPct: number;
}

/** Part of a lot closed by a sell, amounts in the portfolio base currency; the quantity is split-adjusted to the sell date. */
export interface RealizedLotView {
    realizedLotId: number;
    instrumentId: number;
    symbol: string;
    openDate: string;
    closeDate: string;
    quantity: number;
    costBase: number;
    proceedsBase: number;
    realizedPLBase: number;
    currency: string;
}

export interface PortfolioEditModel {
    name: string;
    baseCurrency: string;
    benchmarkInstrumentId: number | null;
    portfolioGroupId: number | null;
}

export interface PriceAlertListItem {
    priceAlertId: number;
    instrumentId: number;
    symbol: string;
    direction: PriceAlertDirection;
    targetPrice: number;
    isActive: boolean;
    createdUtc: string;
    triggeredUtc: string | null;
}

export type PriceAlertDirection = "Above" | "Below";

export interface PriceAlertCreateModel {
    instrumentId: number;
    direction: PriceAlertDirection;
    targetPrice: number;
}

export interface TransactionListItem {
    transactionId: number;
    portfolioId: number;
    instrumentId: number | null;
    symbol: string | null;
    type: TransactionType;
    tradeDate: string;
    quantity: number | null;
    price: number | null;
    amount: number;
    fee: number;
    currencyCode: string;
    fxRateToBase: number | null;
    source: DataProvider;
    note: string | null;
    tradeTimeUtc: string | null;
}

/** Transaction of one holding with what its quantity is worth at the last price, in the requested currency. The quantity is split-adjusted to today; ValueChange is the current value minus the trade cost including fees, valued as the instrument holdings: the cost paid in the trade currency, otherwise through the portfolio base currency, and ValueChangePct is in percent. The current values are null for a transaction without quantity, without a price or FX rate. */
export interface HoldingTransactionView {
    transactionId: number;
    portfolioId: number;
    instrumentId: number | null;
    symbol: string | null;
    type: TransactionType;
    tradeDate: string;
    quantity: number | null;
    price: number | null;
    amount: number;
    fee: number;
    currencyCode: string;
    fxRateToBase: number | null;
    source: DataProvider;
    note: string | null;
    currentValue: number | null;
    valueChange: number | null;
    valueChangePct: number | null;
    tradeTimeUtc: string | null;
}

export interface HoldingMoveModel {
    targetPortfolioId: number;
}

export interface TransactionEditModel {
    type: TransactionType;
    instrumentId: number | null;
    tradeDate: string;
    quantity: number | null;
    price: number | null;
    amount: number | null;
    fee: number;
    currencyCode: string;
    fxRateToBase: number | null;
    note: string | null;
    tradeTimeUtc: string | null;
}

/** Parsed file: column headers (empty texts without a header row), a mapping suggested from the headers, and every data row. */
export interface CsvImportPreview {
    columns: string[];
    suggestedMapping: CsvColumnMapping;
    rows: CsvImportRow[];
    validRows: number;
    duplicateRows: number;
    errorRows: number;
}

/** Zero-based column of each transaction field; null when the file has no such column. */
export interface CsvColumnMapping {
    tradeDate: number | null;
    type: number | null;
    symbol: number | null;
    isin: number | null;
    quantity: number | null;
    price: number | null;
    amount: number | null;
    fee: number | null;
    currencyCode: number | null;
    note: number | null;
    externalId: number | null;
}

/** CSV file content as text, how it is written and which column holds which field. */
export interface CsvImportModel {
    content: string;
    settings: CsvImportSettings;
    mapping: CsvColumnMapping;
}

/** How the CSV text is written; DateFormat is a .NET date format such as yyyy-MM-dd or dd.MM.yyyy. */
export interface CsvImportSettings {
    delimiter: string;
    decimalSeparator: string;
    dateFormat: string;
    hasHeaderRow: boolean;
}

export interface WatchlistItemView {
    instrumentId: number;
    symbol: string;
    name: string;
    currency: string;
    lastPrice: number | null;
    dayChangePct: number | null;
}

export interface WatchlistItemCreateModel {
    instrumentId: number;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}